import axios from 'axios';

import type {
  IUserOrgBasicQuery,
  IUserOrgBasicRequest,
  IUserOrgBasicResponse,
} from '@/app-package';
import type { BuildJsonType } from '@bb/domain/dist/types';

const orgBasic = async (params: IUserOrgBasicQuery) => {
  const config: IUserOrgBasicRequest = {
    url: `/user/org/basic`,
    method: 'get',
    params,
  };

  const { data } =
    await axios.request<BuildJsonType<IUserOrgBasicResponse>>(config);

  return data;
};

export default orgBasic;
